var map = {
	"./banner-mobile-3.jpg": "03c8",
	"./het-gel4.png": "2ef4",
	"./pengajuan-isbn-internal.jpeg": "07b8",
	"./penilaian-btp-sd.jpeg": "892c",
	"./penilaian-btp-smk.png": "4c55",
	"./penilaian-buku-non-teks.jpeg": "e0ad",
	"./penilaian-buku-rekomendasi.jpeg": "6448",
	"./penilaian-buku-teks-pendamping.jpeg": "90e8",
	"./sk-bnt-gelombang-3.png": "a9dd",
	"./sk-btp.png": "89f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd92";